export default class VesselPositionData {
    constructor(etaNextPort, coordinates, insertDate, avgSpeed, meHSFO, meLSFO, meVLSFO, meULSFO) {
        this.etaNextPort = etaNextPort
        this.coordinates = coordinates
        this.insertDate = insertDate
        this.avgSpeed = avgSpeed
        this.meHSFO = meHSFO
        this.meLSFO = meLSFO
        this.meVLSFO = meVLSFO
        this.meULSFO = meULSFO
    }


    get totalConsumption() {
        return this.meHSFO + this.meLSFO + this.meVLSFO + this.meULSFO
    }

}
